var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4975 5.21094H6.66016C6.12972 5.21094 5.62102 5.42165 5.24594 5.79672C4.87087 6.1718 4.66016 6.6805 4.66016 7.21094V25.8909C4.66016 26.4214 4.87087 26.9301 5.24594 27.3052C5.62102 27.6802 6.12972 27.8909 6.66016 27.8909H25.3402C25.8706 27.8909 26.3793 27.6802 26.7544 27.3052C27.1294 26.9301 27.3402 26.4214 27.3402 25.8909V7.21094C27.3402 6.6805 27.1294 6.1718 26.7544 5.79672C26.3793 5.42165 25.8706 5.21094 25.3402 5.21094H18.5028M27.3402 25.1489L18.2402 17.7023M15.9902 21.4976L23.7848 27.8909",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17749 27.891L17.7882 19.9936C17.9394 19.8703 18.0612 19.7148 18.1448 19.5385C18.2285 19.3622 18.2717 19.1694 18.2715 18.9743V17.6276L18.2462 9.94228H22.8415L16.0035 2.55762L9.16682 9.94228H13.7615V17.669L4.66016 25.1136",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.70c392a5817f254bba950d821f24a8a7.svg";
export { ForwardRef as ReactComponent };